import React from "react";
import { GridColumnTitle } from "components/Form";
import Col from "components/Grid/Col";
import Row from "components/Grid/Row";
import Icon from "components/Icon";
import ListDetails from "./listDetails";
import { Container, ListDetail } from "./styles";

const ListQuotes = ({
  columns,
  data,
  handleSortList,
  sortBy,
  navigation
}) => {

  return (
    <Container>

      <ListDetail>
        <Row style={{ marginTop: "20px", marginBottom: "12px" }}>
          {columns.map((column, index) => (
            <Col key={index} md={column.md} sm={column.sm} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <GridColumnTitle
                onClick={() => handleSortList(column.value)}
                style={{ cursor: "pointer" }}
              >
                {column.title}
              </GridColumnTitle>
              <Icon
                style={{ cursor: "pointer" }}
                onClick={() => handleSortList(column.value)}
                name={
                  sortBy.key === column.value && sortBy.direction === "asc"
                    ? "arrowup"
                    : "arrowdown"
                }
              />
            </Col>
          ))}
          <Col style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <GridColumnTitle>AÇÕES</GridColumnTitle>
          </Col>
        </Row>
        <hr></hr>
        {data.map((value) => (
          <ListDetails navigation={navigation} value={value} />
        ))}
      </ListDetail>
    </Container>
  );
};

export default ListQuotes;